import type { ChangeEvent } from 'react'
import type { ControllerRenderProps } from 'react-hook-form'
import type { BranchForForm } from 'types'

import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TextInput } from 'components'
import { trimFirstSpace } from 'helpers/common'

interface IInputPostalCode {
  field: ControllerRenderProps
}

export const InputLocation: React.FC<IInputPostalCode> = ({ field }) => {
  const { errors } = useFormContext<BranchForForm>()

  const { t } = useTranslation(['common'])

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    field.onChange(trimFirstSpace(e))
  }

  return (
    <TextInput
      value={field.value}
      onChange={onChange}
      placeholder={t('common:insertLocationLink.placeholder')}
      isError={Boolean(errors.location?.message)}
      message={errors.location?.message}
      ref={field.ref}
    />
  )
}
